const getCompStatsByListingAliasQuery = (listingAlias) => {
    // validate
    if (!listingAlias) {
        // do not throw new Error otherwise page will not load
        return new Error('listingAlias is required');
    }

    return `
        query getCompStatsByListingAliasQuery {
            byListingAlias(
                listingAlias: "${listingAlias}"
            ) {
                similarFloorplans {
                    stats {
                        startDate
                        endDate
                        views {
                            total
                        }
                        inquiries {
                            total
                        }
                    }
                }
                stats {
                    startDate
                    endDate
                    views {
                        total
                    }
                    inquiries {
                        total
                    }
                }
            }
        }
    `;
};

const getCompsByListingAliasQuery = (listingAlias) => {
    // validate
    if (!listingAlias) {
        // do not throw new Error otherwise page will not load
        return new Error('listingAlias is required');
    }

    return `
        query getCompsByListingAliasQuery {
            byListingAlias(
                listingAlias: "${listingAlias}"
            ) {
                floorplans {
                    aliasEncoded
                    address {
                        street
                        city
                        state
                        zip
                        unit
                    }
                }
              similarFloorplans {
                    lowestPriceIncluded
                    highestPriceIncluded
                    floorplans {
                        aliasEncoded
                    }
              }
            }
          }
    `;
};

export {
    getCompStatsByListingAliasQuery,
    getCompsByListingAliasQuery,
};
